import React from 'react';
import { Helmet } from 'react-helmet-async';

export function DefaultSEO() {
  return (
    <Helmet>
      <html lang="en" />
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      
      {/* Default SEO */}
      <title>Fix Phone Speakers - Professional Audio Testing Tools</title>
      <meta 
        name="description" 
        content="Free online audio testing and repair tools. Fix water-damaged speakers, test audio quality, and enhance sound with professional-grade utilities." 
      />
      <meta 
        name="keywords" 
        content="speaker fix, audio tools, sound repair, water damage, audio test" 
      />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Fix Phone Speakers" />
      <meta property="og:url" content="https://fixphonespeakers.com" />
      <meta property="og:title" content="Fix Phone Speakers - Professional Audio Testing Tools" />
      <meta 
        property="og:description" 
        content="Free online audio testing and repair tools. Fix water-damaged speakers and enhance sound quality." 
      />
      <meta property="og:image" content="https://fixphonespeakers.com/og-image.jpg" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Fix Phone Speakers" />
      <meta 
        name="twitter:description" 
        content="Professional audio testing and repair tools" 
      />
      <meta name="twitter:image" content="https://fixphonespeakers.com/twitter-card.jpg" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Fix Phone Speakers",
          "url": "https://fixphonespeakers.com",
          "description": "Professional audio testing and repair tools",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://fixphonespeakers.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
    </Helmet>
  );
}